import { render, staticRenderFns } from "./ProductsDetail.vue?vue&type=template&id=5c4f9d28&scoped=true&"
import script from "./ProductsDetail.vue?vue&type=script&lang=js&"
export * from "./ProductsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductsDetail.vue?vue&type=style&index=0&id=5c4f9d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4f9d28",
  null
  
)

export default component.exports